import request from "../util/request";
// 登录方法
export function login(username, password, code, uuid) {
  const data = {
    userName: username,
    password,
    code,
    uuid
  }
  return request({
    url: '/api-admin/login/user',
    headers: {
      isToken: false
    },
    method: 'post',
    data: data
  })
}

// 注册方法
export function register(data) {
  return request({
    url: '/api-admin/register',
    headers: {
      isToken: false
    },
    method: 'post',
    data: data
  })
}

// 获取用户详细信息
export function getInfo() {
  return request({
    url: '/api-admin/user/admin/login/info',
    method: 'get'
  })
}

// 退出方法
export function logout() {
  return request({
    headers: {
      isToken: true
    },
    url: '/api-admin/login/logout',
    method: 'post'
  })
}

// 获取验证码
export function getCodeImg() {
  return request({
    url: '/api-admin/captcha/image',
    headers: {
      isToken: false
    },
    method: 'get',
    timeout: 20000
  })
}
//获取手机号验证码
export function getPhoneCode(data){
  return request({
    url:'/api-admin/phoneMessage/send',
    method:'post',
    headers: {
      isToken: false
    },
    params:data
  })
}
//手机号码登录
export function loginPhone(data) {
  return request({
    url: '/api-admin/login/phone',
    headers: {
      isToken: false
    },
    method: 'post',
    data: data

  })
}

/**
 * 获取所有用户(排除掉管理员用户)
 * @returns {*}
 */
export function getUsersExcludeAdmin() {
  return request({
    url: '/api-admin/user/admin/login/info/exclude/admin',
    method: 'get'
  })
}

